import React from 'react';
import { Grid, Illustration, Textblock, Typography } from '@screentone/core';

export const ErrorPage = () => (
  <Grid>
    <Grid.Row>
      <Grid.Col xs={12} md={12}>
        <Illustration name="404" className="st-addon-okta-error-page-illustration" />
        <Typography align="center" variant="header1">
          Nothing to see Here
        </Typography>
        <Textblock className="st-addon-okta-error-page-text">
          Page not found. Please make sure your url is in correct format. If you need further
          assistance contact{' '}
          <a
            href="https://dowjones.slack.com/archives/C4F0ANBU4"
            target="_blank"
            rel="noopener noreferrer"
          >
            #chartlos team on slack
          </a>
        </Textblock>
      </Grid.Col>
    </Grid.Row>
  </Grid>
);
